import { Button } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface LeadCollectorTabHeaderProps {
  title: string;
  onChooseForm: () => void;
  isDisabledChooseForm?: boolean;
  onClickCreateForm?: () => void;
}

export const LeadCollectorTabHeader = ({
  title,
  onChooseForm,
  isDisabledChooseForm,
  onClickCreateForm,
}: LeadCollectorTabHeaderProps) => (
  <div {...stylex.props(styles.container)}>
    <p {...stylex.props(styles.title)}>{title}</p>

    <div {...stylex.props(styles.actions)}>
      <Button variant="secondary" size="small" onClick={onClickCreateForm} isDisabled={!onClickCreateForm}>
        Создать новый
      </Button>

      <Button variant="accent" size="small" isDisabled={isDisabledChooseForm} onClick={onChooseForm}>
        Выбрать шаблон
      </Button>
    </div>
  </div>
);
